import {MutationRequest, MutationRequestButtonState} from './types';

export type UseMutationButtonReturnType = {
    [k: string]: MutationRequestButtonState | undefined;
};
const useMutationButtonProps = (
    requests: Record<string, MutationRequest>,
): UseMutationButtonReturnType =>
    Object.fromEntries(
        Object.entries(requests).map(([key, state]) => [
            key,
            {
                disabled: state === 'pending',
                isLoading: state === 'pending',
            },
        ]),
    );

export default useMutationButtonProps;
